(() => {
  if (customElements.get('joffz-reward-review')) return;
  class RewardReview extends HTMLElement {
    connectedCallback() {
      if (this.controller || !window.JoffzRewardsCore) return;
      this.live=this.dataset.reviewOnly==='false';
      this.member=this.live&&this.dataset.member==='true';
      this.legacyCompleted=this.hasLegacyCompletion();
      this.core=window.JoffzRewardsCore;
      this.dialog=this.querySelector('[data-rw-dialog]');
      if (!this.dialog?.showModal) return;
      this.controller=new AbortController();
      this.strings=JSON.parse(this.querySelector('[data-rw-strings]').textContent);
      this.refreshMoney();
      this.launcher=this.querySelector('[data-rw-launch]');
      this.cards=[...this.querySelectorAll('[data-rw-card]')];
      this.storageKey=this.live?'joffz-art-club-codes-20261028-v1':`joffz-reward-review-${this.dataset.themeId}-${this.core.version}`;
      this.sessionKey='joffz-art-club-six-seen-v1';
      this.codes={};this.readState();
      this.nativeForm=this.querySelector('form');
      this.nativeSuccess=Boolean(this.live&&this.querySelector('[data-rw-native-success]')&&location.hash===`#RewardSignup-${this.dataset.sectionId}`);
      this.nativeError=Boolean(this.live&&this.querySelector('[data-rw-native-error]')&&location.hash===`#RewardSignup-${this.dataset.sectionId}`);
      this.nativeCodes={};
      if(this.live&&(this.member||this.nativeSuccess)){
        try{this.nativeCodes=this.cleanCodes(JSON.parse(this.querySelector('[data-rw-native-codes]')?.textContent||'{}'));}catch(_){}
      }
      if(this.nativeSuccess){
        try{
          const pending=JSON.parse(sessionStorage.getItem(this.storageKey+'-pending'));
          if(this.state.revealed.length!==3&&pending&&Date.now()-pending.at<1800000)this.state=this.core.clean(pending.state);
        }catch(_){}
        this.complete();
      }
      if(this.nativeSuccess||this.nativeError)try{sessionStorage.removeItem(this.storageKey+'-pending');}catch(_){}
      this.listen(this.launcher,'click',()=>this.open());
      this.querySelectorAll('[data-rw-close]').forEach(b=>this.listen(b,'click',()=>this.close()));
      this.listen(this.dialog,'cancel',e=>{e.preventDefault();this.close();});
      this.listen(this.dialog,'close',()=>this.afterClose());
      this.cards.forEach(b=>this.listen(b,'click',()=>this.pick(b)));
      this.listen(this.querySelector('[data-rw-see]'),'click',()=>this.showChoices());
      this.listen(this.querySelector('[data-rw-back]'),'click',()=>this.stage('cards',true));
      this.listen(this.querySelector('[data-rw-continue]'),'click',()=>{
        if(this.busy || this.state.completed || this.state.revealed.length!==3)return;
        if(!this.complete())return;
        this.renderSaved();this.stage('saved',true);this.launcher.hidden=true;this.emit('three_cards_saved');
      });
      this.listen(this.nativeForm,'submit',e=>{
        if(this.busy||this.state.revealed.length!==3){e.preventDefault();this.showSignupError(this.strings.required);return;}
        if(!this.nativeForm.reportValidity()){e.preventDefault();return;}
        try{sessionStorage.setItem(this.storageKey+'-pending',JSON.stringify({state:this.state,at:Date.now()}));}
        catch(_){e.preventDefault();this.showSignupError(this.strings.error);return;}
        this.save();this.busy=true;
        this.querySelector('[data-rw-submit]').disabled=true;
      });
      this.listen(document,'click',e=>{
        const link=e.target.closest('a[href]');
        if(!link || link.hash!=='#art-club')return;
        const url=new URL(link.href,location.href);
        if(url.origin!==location.origin || url.pathname!==location.pathname)return;
        e.preventDefault();this.open();
      });
      this.listen(window,'hashchange',()=>{if(location.hash==='#art-club')this.open();});
      this.listen(window,'pageshow',()=>{this.busy=false;const submit=this.querySelector('[data-rw-submit]');if(submit)submit.disabled=false;this.restore();});
      this.listen(window,'storage',e=>{if(e.key===this.storageKey){this.close();this.restore();}});
      this.listen(document,'visibilitychange',()=>{if(document.visibilityState==='visible'&&!this.dialog.open)this.restore();});
      this.listen(document,'shopify:section:unload',e=>{if(e.detail?.sectionId===this.dataset.sectionId)this.teardown();});
      this.renderCards(false);
      this.setupLauncherWindow();
      if(this.state.completed){this.renderSaved();this.stage('saved');}
      else if(this.state.revealed.length===3)this.showChoices(false);
      else this.stage('cards');
      if(location.hash==='#art-club'||new URLSearchParams(location.search).get('art_club')==='preview'||this.nativeSuccess||this.nativeError)this.open();
      else if(this.live&&this.dataset.autoOpen==='true'&&!this.state.completed&&!this.member&&!this.legacyCompleted&&!window.Shopify?.designMode){
        let seen=true;try{seen=sessionStorage.getItem(this.sessionKey)==='1';}catch(_){}
        if(!seen)this.autoTimer=setTimeout(()=>{
          if(!document.hidden&&!this.state.completed&&!this.member&&!this.legacyCompleted)this.open();
        },Math.max(3,Number(this.dataset.delay)||25)*1000);
      }
    }
    setupLauncherWindow() {
      const key = 'joffz-art-club-launcher-until-v1';
      this.launcherExpiresAt = Date.now() + 20000;
      try {
        const stored = Number(sessionStorage.getItem(key));
        if (Number.isFinite(stored) && stored > 0) this.launcherExpiresAt = stored;
        else sessionStorage.setItem(key, String(this.launcherExpiresAt));
      } catch (_) {}
      this.listen(this.launcher, 'pointerleave', () => this.syncLauncher());
      this.listen(this.launcher, 'blur', () => this.syncLauncher());
      this.listen(this.launcher, 'focus', () => this.syncLauncher());
      this.syncLauncher();
    }

    syncLauncher() {
      clearTimeout(this.launcherTimer);
      clearTimeout(this.launcherHideTimer);
      if (!this.controller || !this.launcher) return;
      if (this.state.completed || this.member || this.legacyCompleted || this.dialog.open || /(^|\/)(checkouts?|account)(\/|$)/i.test(location.pathname)) {
        this.launcher.hidden = true;
        this.launcher.classList.remove('is-expiring');
        return;
      }
      const remaining = this.launcherExpiresAt - Date.now();
      if (remaining <= 0) {
        // Never remove the control while a visitor is using it with a pointer or keyboard.
        if (this.launcher.contains(document.activeElement) || this.launcher.matches(':hover')) {
          this.launcher.classList.remove('is-expiring');
          return;
        }
        if (this.launcher.hidden) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.launcher.hidden = true;
        } else {
          this.launcher.classList.add('is-expiring');
          this.launcherHideTimer = setTimeout(() => {
            this.launcher.hidden = true;
            this.launcher.classList.remove('is-expiring');
          }, 180);
        }
        return;
      }
      this.launcher.classList.remove('is-expiring');
      this.launcher.hidden = false;
      this.launcherTimer = setTimeout(() => this.syncLauncher(), remaining);
    }

    refreshMoney(){
      const base=this.dataset.baseCurrency||'EUR', expected=this.dataset.currency||base;
      const native=window.Shopify?.currency, rate=Number(native?.rate);
      const valid=native?.active===expected&&Number.isFinite(rate)&&rate>0&&rate<1000000;
      const converted=expected!==base&&valid, currency=converted?expected:base;
      const locale=document.documentElement.lang||'en';
      const symbols={USD:'$',CAD:'C$',AUD:'A$',EUR:'€',GBP:'£',CHF:'Fr.',TRY:'₺'};
      let formatter;
      try{
        const localized=new Intl.NumberFormat(locale,{style:'currency',currency,currencyDisplay:'narrowSymbol',minimumFractionDigits:0,maximumFractionDigits:2});
        formatter={format:n=>localized.formatToParts(n).map(part=>part.type==='currency'?(symbols[currency]||part.value):part.value).join('')};
      }
      catch(_){formatter={format:n=>n.toFixed(2)+' '+(symbols[currency]||currency)};}
      const money=n=>formatter.format(Number(n)*(converted?rate:1));
      const roots=[this,...[...this.querySelectorAll('template')].map(t=>t.content)];
      for(const root of roots)for(const el of root.querySelectorAll('[data-rw-money-template]')){
        const text=el.dataset.rwMoneyTemplate.replaceAll('__AMOUNT__',money(el.dataset.rwAmount)).replaceAll('__MINIMUM__',money(el.dataset.rwMinimum));
        if(el.tagName==='TEMPLATE')el.content.textContent=text;else el.textContent=text;
      }
      const note=this.querySelector('[data-rw-currency-note]');
      if(note){
        note.hidden=expected===base;
        note.textContent=(converted?this.strings.currencyNote:this.strings.currencyFallback||'').replaceAll('__CURRENCY__',symbols[expected]||expected).replaceAll('__BASE__',symbols[base]||base);
      }
    }
    listen(target,event,callback){target?.addEventListener(event,callback,{signal:this.controller.signal});}
    hasLegacyCompletion(){
      if(!this.live)return false;
      try{if(localStorage.getItem('joffz-art-club-completed-v1')==='1')return true;}catch(_){}
      return document.cookie.split(';').some(value=>value.trim()==='joffz-art-club-completed-v1=1');
    }
    emit(name,id){
      if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()!==true)return;
      this.dispatchEvent(new CustomEvent(this.live?'joffz:reward:interaction':'joffz:reward:review',{bubbles:true,detail:{name,offer_id:id||null,review:!this.live}}));
    }
    cleanCodes(input){
      const codes={};
      for(const id of this.core.ids)if(typeof input?.[id]==='string'&&/^[A-Za-z0-9_-]{1,100}$/.test(input[id]))codes[id]=input[id];
      return codes;
    }
    readState(){
      let saved=null;
      try{saved=JSON.parse(localStorage.getItem(this.storageKey));}catch(_){}
      if(!saved)try{saved=JSON.parse(sessionStorage.getItem(this.storageKey));}catch(_){}
      this.state=this.core.clean(saved);this.codes=this.live?this.cleanCodes(saved?.codes):{};
      if(this.live&&this.state.completed&&!this.state.revealed.every(id=>this.codes[id]))this.state.completed=false;
    }
    complete(){
      if(this.state.revealed.length!==3)return false;
      if(this.live){
        if(!(this.member||this.nativeSuccess)||!this.state.revealed.every(id=>this.nativeCodes[id])){this.showSignupError(this.strings.unavailable);return false;}
        this.codes=Object.fromEntries(this.state.revealed.map(id=>[id,this.nativeCodes[id]]));
      }
      this.state=this.core.complete(this.state);this.save();return true;
    }
    save(){
      const stored={...this.state};
      if(this.live&&this.state.completed)stored.codes=this.codes;
      try{localStorage.setItem(this.storageKey,JSON.stringify(stored));}catch(_){}
      try{sessionStorage.setItem(this.storageKey,JSON.stringify(stored));}catch(_){}
    }
    showSignupError(message){const box=this.querySelector('[data-rw-error]');if(box){box.textContent=message;box.hidden=false;}this.querySelector('[data-rw-announce]').textContent=message;}
    restore(){
      if(this.dialog.open)return;
      this.readState();
      this.refreshMoney();
      this.legacyCompleted=this.hasLegacyCompletion();
      this.renderCards(false);this.syncLauncher();
      if(this.state.completed){this.renderSaved();this.stage('saved');}
      else if(this.state.revealed.length===3)this.showChoices(false);
      else this.stage('cards');
    }
    pick(card){
      if(this.state.completed || this.state.revealed.length>=3 || this.state.revealed.includes(card.dataset.rwCard))return;
      const id=card.dataset.rwCard;
      this.state=this.core.reveal(this.state,id);this.save();
      card.classList.add('is-revealing');
      this.renderCards(true);
      const label=card.querySelector('.jac__card-back').textContent.trim().replace(/\s+/g,' ');
      this.querySelector('[data-rw-announce]').textContent=this.strings.revealed.replace('__OFFER__',label);
      this.emit('card_revealed',id);
      if(this.state.revealed.length===3){
        this.advanceTimer=setTimeout(()=>{if(this.dialog.open)this.showChoices();},matchMedia('(prefers-reduced-motion:reduce)').matches?0:920);
      }else this.cards.find(b=>!b.disabled)?.focus({preventScroll:true});
    }
    renderCards(animate){
      this.cards.forEach(card=>{
        const picked=this.state.revealed.includes(card.dataset.rwCard);
        if(!animate)card.classList.remove('is-revealing');
        card.classList.toggle('is-picked',picked);
        card.disabled=picked || this.state.revealed.length>=3 || this.state.completed;
        card.setAttribute('aria-pressed',String(picked));
        if(picked)card.setAttribute('aria-label',this.strings.revealed.replace('__OFFER__',card.querySelector('.jac__card-back').textContent.trim().replace(/\s+/g,' ')));
      });
      this.querySelector('[data-rw-progress]').textContent=this.strings.progress.replace('__COUNT__',String(this.state.revealed.length));
      this.querySelector('[data-rw-see]').hidden=this.state.revealed.length!==3;
    }
    showChoices(focus=true){
      if(this.state.revealed.length!==3)return;
      this.renderRetained(this.querySelector('[data-rw-choices]'));
      const keep=this.querySelector('[data-rw-continue]');
      keep.disabled=this.state.completed;
      keep.hidden=this.live&&!this.member&&!this.nativeSuccess;
      this.stage('choice',focus);
    }
    renderRetained(box){
      box.replaceChildren();
      this.state.revealed.forEach(id=>{
        const card=document.createElement('article');card.className='jac__choice';card.dataset.rwRetained=id;
        card.append(this.querySelector(`[data-rw-offer="${id}"]`).content.cloneNode(true));
        const details=document.createElement('details');details.className='jac__terms';
        const summary=document.createElement('summary');summary.textContent=this.strings.terms;
        const terms=document.createElement('p');terms.textContent=this.querySelector(`[data-rw-terms="${id}"]`).content.textContent;
        details.append(summary,terms);
        const eligible=this.querySelector('[data-rw-eligible="'+id+'"]');
        if(eligible)details.append(eligible.content.cloneNode(true));
        card.append(details);box.append(card);
      });
    }
    renderSaved(){
      const box=this.querySelector('[data-rw-saved-offer]');this.renderRetained(box);
      if(!this.live)return;
      box.querySelectorAll('[data-rw-retained]').forEach(card=>{
        const id=card.dataset.rwRetained,code=this.codes[id];if(!code)return;
        const controls=document.createElement('div');controls.className='jac__reward-code';
        const label=document.createElement('span');label.className='jac__code-label';label.textContent=this.strings.codeLabel;
        const value=document.createElement('strong');value.className='jac__code-value';value.textContent=code;
        const copy=document.createElement('button');copy.type='button';copy.className='jac__copy';copy.textContent=this.strings.copy;
        copy.addEventListener('click',async()=>{
          try{await navigator.clipboard.writeText(code);copy.textContent=this.strings.copied;this.querySelector('[data-rw-announce]').textContent=this.strings.copied;}
          catch(_){const range=document.createRange();range.selectNodeContents(value);const selection=window.getSelection();selection.removeAllRanges();selection.addRange(range);value.focus();}
        });
        value.tabIndex=0;
        const apply=document.createElement('a');apply.className='jac__primary jac__code-apply';apply.textContent=this.strings.apply;
        const destination=id==='bonus_art'?this.dataset.posterUrl:this.dataset.shopUrl;
        apply.href=`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(destination||'/collections/all')}`;
        controls.append(label,value,copy,apply);card.append(controls);
      });
    }
    stage(name,focus=false){
      this.dataset.stage=name;this.querySelectorAll('[data-rw-stage]').forEach(p=>p.hidden=p.dataset.rwStage!==name);
      const title=this.querySelector('[data-rw-title]');title.textContent=this.strings[name==='cards'?'title':name==='choice'?'choice':'saved'];
      this.querySelector('[data-rw-scroll]').scrollTop=0;
      if(focus)this.focusFrame=requestAnimationFrame(()=>{if(this.dialog.open)title.focus({preventScroll:true});});
    }
    open(){
      if(this.dialog.open)return;
      this.refreshMoney();
      this.renderCards(false);
      const conflict=[...document.querySelectorAll('dialog[open],[aria-modal="true"],.popup-open')].some(n=>n!==this.dialog&&n.getClientRects().length&&getComputedStyle(n).visibility!=='hidden');
      if(conflict)return;
      this.returnFocus=document.activeElement;this.scrollY=window.scrollY;
      this.savedStyles=[];
      for(const [node,properties] of [[document.body,['position','top','width','overflow','padding-right']],[document.documentElement,['overflow','scrollbar-gutter']]])
        for(const property of properties)this.savedStyles.push({node,property,value:node.style.getPropertyValue(property),priority:node.style.getPropertyPriority(property)});
      const scrollbar=Math.max(0,innerWidth-document.documentElement.clientWidth);
      const padding=parseFloat(getComputedStyle(document.body).paddingRight)||0;
      document.documentElement.style.setProperty('overflow','hidden');document.documentElement.style.setProperty('scrollbar-gutter','auto');
      Object.assign(document.body.style,{position:'fixed',top:`-${this.scrollY}px`,width:'100%',overflow:'hidden'});
      if(scrollbar)document.body.style.paddingRight=`${padding+scrollbar}px`;
      try{this.dialog.showModal();}catch(_){this.restoreStyles();return;}
      clearTimeout(this.autoTimer);
      if(this.live)try{sessionStorage.setItem(this.sessionKey,'1');}catch(_){}
      this.syncLauncher();
      this.launcher.setAttribute('aria-expanded','true');
      if(this.state.completed){this.renderSaved();this.stage('saved',true);}
      else if(this.state.revealed.length===3)this.showChoices();
      else this.stage('cards',true);
      this.emit('impression');
    }
    close(){if(this.dialog.open){
      const url=new URL(location.href);
      if(url.hash==='#art-club'||url.hash==='#RewardSignup-'+this.dataset.sectionId){
        url.hash='';url.searchParams.delete('customer_posted');
        history.replaceState(history.state,'',url.pathname+url.search);
      }
      this.dialog.close();this.afterClose();
    }}
    afterClose(){if(!this.savedStyles)return;clearTimeout(this.advanceTimer);cancelAnimationFrame(this.focusFrame);this.restoreStyles();this.launcher.setAttribute('aria-expanded','false');this.syncLauncher();if(this.returnFocus?.isConnected&&!this.returnFocus.hidden&&this.returnFocus.getClientRects().length)this.returnFocus.focus({preventScroll:true});this.emit('dismissal');}
    restoreStyles(){
      if(!this.savedStyles)return;
      this.savedStyles.forEach(({node,property,value,priority})=>{if(value)node.style.setProperty(property,value,priority);else node.style.removeProperty(property);});this.savedStyles=null;
      window.scrollTo({top:this.scrollY,left:window.scrollX,behavior:'instant'});
    }
    teardown(){clearTimeout(this.autoTimer);clearTimeout(this.advanceTimer);cancelAnimationFrame(this.focusFrame);this.close();clearTimeout(this.launcherTimer);clearTimeout(this.launcherHideTimer);this.restoreStyles();this.controller?.abort();this.controller=null;}
    disconnectedCallback(){this.teardown();}
  }
  customElements.define('joffz-reward-review',RewardReview);
})();
